import { useEffect, useState } from 'react';
import { listCourses } from '../services/courseService';
import { getStudentEnrollments } from '../services/enrollmentService';
import { mapCoursesToEnrollments } from '../utils/courseAccess';

export function useCoursesByRole(currentUser) {
  const [state, setState] = useState({
    items: [],
    loading: false,
    error: '',
  });

  useEffect(() => {
    let cancelled = false;
    async function fetchData() {
      setState((prev) => ({ ...prev, loading: true, error: '' }));
      try {
        if (currentUser?.role === 'teacher') {
          const data = await listCourses();
          if (cancelled) return;
          const mapped = mapCoursesToEnrollments(data?.courses || []);
          setState({ items: mapped, loading: false, error: '' });
          return;
        }

        if (currentUser?.role === 'student') {
          const studentId = currentUser?.id || currentUser?._id;
          if (!studentId) {
            setState({ items: [], loading: false, error: '' });
            return;
          }
          const data = await getStudentEnrollments(studentId);
          if (cancelled) return;
          setState({ items: data?.enrollments || [], loading: false, error: '' });
          return;
        }

        // Default: fall back to empty list for other roles.
        setState({ items: [], loading: false, error: '' });
      } catch (error) {
        if (cancelled) return;
        setState({ items: [], loading: false, error: error.message || 'Unable to load courses.' });
      }
    }

    fetchData();
    return () => {
      cancelled = true;
    };
  }, [currentUser]);

  return state;
}
